var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-navbar__item",class:_vm.selected ? 'weui-bar__item_on' : '',on:{"click":function($event){return _vm.select()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }